import { ISelectType } from "@4uhub/lib4uhub";
import { GlobalAxios } from "../axios/axios-config";
import {
  IProfileDashboardPanel,
  IProfileDashboardPanelsPayload,
} from "../models/profile-dashboard-panel";
import { ISearchParams, ISearchReturn } from "../models/requests";

const PROFILE_DASHBOARD_PANELS_ROUTE =
  process.env.REACT_APP_IDENTIY + "/api/v1/ProfileDashboardPanels/";

const DASHBOARD_PANEL_ROUTE =
  process.env.REACT_APP_MAIN + "/api/v1/DashboardPanel/";

export const getRoleDashboardPanels = (
  params?: ISearchParams & { RoleId: string }
) => {
  return GlobalAxios.get<ISearchReturn<IProfileDashboardPanel>>(
    PROFILE_DASHBOARD_PANELS_ROUTE,
    {
      params,
    }
  );
};

export const createRoleDashboardPanels = (
  item: IProfileDashboardPanelsPayload
) => {
  return GlobalAxios.post(PROFILE_DASHBOARD_PANELS_ROUTE, item);
};

export const updateRoleDashboardPanels = ({
  id,
  item,
}: {
  id: string;
  item: IProfileDashboardPanelsPayload;
}) => {
  return GlobalAxios.put(PROFILE_DASHBOARD_PANELS_ROUTE + id, item);
};

export const deleteRoleDashboardPanel = (id: string) => {
  return GlobalAxios.delete(PROFILE_DASHBOARD_PANELS_ROUTE + id);
};

export const listDashboardPanels = (params?: ISearchParams) => {
  return GlobalAxios.get<ISelectType[]>(`${DASHBOARD_PANEL_ROUTE}list`, {
    params,
  });
};
